export enum OrderStatus {
  CART = 'CART',
  SUBMITTED = 'SUBMITTED',
  CONFIRMED = 'CONFIRMED',
  PREPARING = 'PREPARING',
  READY = 'READY',
  DELIVERED = 'DELIVERED',
  CANCELLED = 'CANCELLED'
}

export enum NotificationType {
  ORDER_CREATED = 'ORDER_CREATED',
  ORDER_CONFIRMED = 'ORDER_CONFIRMED',
  PREPARATION_STARTED = 'PREPARATION_STARTED',
  ORDER_READY = 'ORDER_READY',
  ORDER_DELIVERED = 'ORDER_DELIVERED',
  STATUS_UPDATE = 'STATUS_UPDATE',
  TIME_UPDATE = 'TIME_UPDATE'
}

export interface OrderNotification {
  orderId: string
  customerId: string
  restaurantId: string
  status: OrderStatus
  message: string
  estimatedPreparationTime?: number // in minutes
  remainingTime?: number // calculated remaining time in minutes
  timestamp: string // ISO 8601 format
  type: NotificationType
}
